<template>
  <div>
        <div class="style-editor">
            <div
                v-for="group in nonEmptyStyleGroups" 
                :key="group.name"
                class="style-editor-group" 
            >
                <div class="style-editor-label">
                    <span style="font-size: 14px; font-weight: bold;">
                        {{ group.label }}
                    </span>
                </div>
                <div class="style-editor-items">
                    <template
                        v-for="property in group.items"
                    >
                        <div
                            v-if="group.items.includes(property) && allowedProperties.includes(property)"
                            :key="property"
                            class="style-editor-item"
                            :class="styleProperties[property]['cssClasses']"
                        >
                            <div v-if="styleProperties[property]['type'] === 'numeric'">
                                <div class="style-editor-input-label">
                                    {{ styleProperties[property]['label'] }}
                                </div>
                                <div
                                    class="number-minus"
                                    @click="decreaseNumber(property)"
                                >
                                    <i class="fa fa-minus" />
                                </div>
                                <input 
                                    v-model="properties[property]"
                                    type="number"
                                    title=""
                                    class="form-control style-input"
                                    :max="styleProperties[property]['max']"
                                    :min="styleProperties[property]['min']"
                                    @input.stop.prevent="validateUpdate(property)"
                                    @change.stop.prevent="validateUpdate(property)"
                                >
                                <div
                                    class="number-plus"
                                    @click="increaseNumber(property)"
                                >
                                    <i class="fa fa-plus" />
                                </div>
                            </div>

                            <div v-if="styleProperties[property]['type'] === 'string'">
                                <div class="style-editor-input-label">
                                    {{ styleProperties[property]['label'] }}
                                </div>
                                <select
                                    v-model="properties[property]"
                                    type="text"
                                    title=""
                                    class="form-control form-control-sm style-input"
                                    :placeholder="styleProperties[property]['label']"
                                    @change="emitChange"
                                >
                                    <option 
                                        v-for="choice in styleProperties[property]['choices']"
                                        :key="choice.value"
                                        :value="choice.value"
                                    >
                                        {{ choice.label }}
                                    </option>
                                </select>
                            </div>

                            <div v-if="styleProperties[property]['type'] === 'image'">
                                <div
                                    style="position: relative; margin: 0 auto;"
                                    :style="{'width': bgImageWidth+'px'}"
                                >
                                    <croppa 
                                        v-model="image"
                                        accept="image/*"
                                        placeholder="Выберите изображение"

                                        :initial-image="(data.bgImage && data.bgImage.url) ? data.bgImage.url : ''"
                                        :height="bgImageHeight"
                                        :width="bgImageWidth"
                                        :canvas-color="'transparent'"
                                        :file-size-limit="4*1024*1024"
                                        :disabled="false"
                                        :prevent-white-space="true"
                                        :auto-sizing="false"
                                        :zoom-speed="3"
                                        :show-remove-button="false"

                                        @file-type-mismatch="fileTypeMismatchMessage"
                                        @file-size-exceed="fileSizeExceededMessage"
                                        @new-image="saveOriginalImage"
                                        @init="restoreImageMetadata"
                                        @move="updatePreview"
                                        @zoom="updatePreview"
                                        @initial-image-loaded="restoreImageMetadata"
                                    />
                                    <div
                                        class="horizontal-resize-handle control small left"
                                        style="left: 0;"
                                        @mousedown="startImgHorizontalResize($event, 'left')"
                                    >
                                        <span class="fa fa-ellipsis-h" />
                                    </div>
                                    <div
                                        class="horizontal-resize-handle control small right"
                                        style="right: 0"
                                        @mousedown="startImgHorizontalResize($event, 'right')"
                                    >
                                        <span class="fa fa-ellipsis-h" />
                                    </div>
                                    <div
                                        class="vertical-resize-handle small control"
                                        @mousedown="startImgVerticalResize"
                                    >
                                        <span class="fa fa-ellipsis-h" />
                                    </div>
                                </div>
                                <div class="croppa-image-upload">
                                    <span
                                        class="btn btn-secondary"
                                        title="Загрузить изображение"
                                        style="flex: 1; margin: 5px;"
                                        @click="image.chooseFile()"
                                    >
                                        <i class="fa fa-lg fa-cloud-upload" />
                                    </span>
                                    <span
                                        v-if="!hidefilebrowser && $root.siteId"
                                        class="btn btn-secondary"
                                        title="Выбрать из загруженных"
                                        style="flex: 1;  margin: 5px;"
                                        @click="browser=true"
                                    >
                                        <i class="fa fa-lg fa-list-alt" />
                                    </span>
                                    <span
                                        v-if="inline && image && image.hasImage()"
                                        class="btn btn-success"
                                        title="Сохранить"
                                        style="flex: 1;  margin: 5px;"
                                        @click="saveEditedImage()"
                                    >
                                        <i class="fa fa-lg fa-save" />
                                    </span>
                                    <span
                                        v-if="image && image.hasImage()"
                                        title="Удалить фоновое изображение"
                                        class="btn btn-danger"
                                        style="flex: 1; margin: 5px;"
                                        @click="removeImage"
                                    >
                                        <i class="fa fa-times" />
                                    </span>
                                    <filebrowser
                                        v-if="!hidefilebrowser"
                                        :active="browser"
                                        @close="browser=false"
                                        @imagechosen="changeImage"
                                    />
                                </div>
                            </div>
                            <color-picker 
                                v-if="styleProperties[property]['type'] === 'color'" 
                                :color="properties[property]"
                                :palette="['transparent', ...$root.palette]"
                                :usercolors="true"
                                :top="true"
                                @change="updateProperty($event, property)" 
                            />
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div v-if="allowedProperties.includes('width') && !inline">
            <div
                v-if="[undefined, 'center', 'right'].includes(properties.align)"
                class="horizontal-resize-handle control left"
                :style="{left: (100-properties.width)/(properties.align === 'right' ? 1 : 2)+'%'}"
                @mousedown="startHorizontalResize($event, 'left')"
            >
                <span class="fa fa-ellipsis-h" />
            </div>
            <div
                v-if="[undefined, 'center', 'left'].includes(properties.align)"
                class="horizontal-resize-handle control right"
                :style="{right: (100-properties.width)/(properties.align === 'left' ? 1 : 2)+'%'}"
                @mousedown="startHorizontalResize($event, 'right')"
            >
                <span class="fa fa-ellipsis-h" />
            </div>
        </div>
        <div
            v-if="allowedProperties.includes('height') && !inline" 
            class="vertical-resize-handle control"
            @mousedown="startVerticalResize"
        >
            <span class="fa fa-ellipsis-h" />
        </div>
    </div>
</template>

<script>
    import ComponentMixin from './Component.vue';
    import ColorPicker from './ColorPicker.vue';
    import Croppa from 'vue-croppa';
    import FileBrowser from './FileBrowser.vue';

    let styleGroups = [
        {label: 'Блок', items: ['height', 'width','borderRadius', 'align', 'verticalAlign']},
        {label: 'Внутренние отступы', items: ['paddingTop', 'paddingBottom', 'paddingRight', 'paddingLeft']},
        {label: 'Внешние отступы', items: ['marginTop', 'marginBottom', 'marginRight', 'marginLeft']},
        {label: 'Рамка', items: ['borderTopWidth', 'borderBottomWidth', 'borderLeftWidth', 'borderRightWidth', 'borderColor', 'borderStyle',]},
        {label: 'Фон', items: ['backgroundImage', 'backgroundColor', 'backgroundRepeat', 'backgroundSize']}
    ]

    let styleProperties = {
        height: {
            type: 'numeric', label: 'Высота', min: 0, max: 1000, units: 'px', default: 'auto', cssClasses: ['quarter']
        },
        width: {
            type: 'numeric', label: 'Ширина', min: 0, max: 100, units: '%', default: 100, cssClasses: ['quarter']
        },
        borderRadius: {
            type: 'numeric', label: 'Радиус', min: 0, max: 100, units: 'px', default: 0, cssClasses: ['quarter']
        },
        align: {
            type: 'string', label: '', default: 'center', cssClasses: ['full'],
            choices: [
                {value: 'left', label: 'По левому краю'},
                {value: 'right', label: 'По правому краю'},
                {value: 'center', label: 'По центру'}
            ]
        },
        verticalAlign: {
            type: 'string', label: '', default: 'middle', cssClasses: ['full'],
            choices: [
                {value: 'top', label: 'По верхнему краю'},
                {value: 'middle', label: 'По центру'},
                {value: 'bottom', label: 'По нижнему краю'}
            ]
        },
        borderStyle: {
            type: 'string', default: 'solid', cssClasses: ['stretch'],
            choices: [
                {'value': 'solid', 'label': 'Цельная'},
                {'value': 'dotted', 'label': 'Точки'},
                {'value': 'dashed', 'label': 'Тире'}
            ]
        },
        borderTopWidth: {
            type: 'numeric', label: 'Верняя', min: 0, max: 100, units: 'px', default: 0, cssClasses: ['quarter']
        },
        borderBottomWidth: {
            type: 'numeric', label: 'Нижняя', min: 0, max: 100, units: 'px', default: 0, cssClasses: ['quarter']
        },
        borderLeftWidth: {
            type: 'numeric', label: 'Левая', min: 0, max: 100, units: 'px', default: 0, cssClasses: ['quarter']
        },
        borderRightWidth: {
            type: 'numeric', label: 'Правая', min: 0, max: 100, units: 'px', default: 0, cssClasses: ['quarter']
        },
        borderColor: {
            type: 'color', label: 'Цвет', default: 'transparent', cssClasses: ['color']
        },
        marginTop: {
            type: 'numeric', label: 'Сверху', min: 0, max: 100, units: 'px', default: 0, cssClasses: ['quarter']
        },
        marginBottom: {
            type: 'numeric', label: 'Снизу', min: 0, max: 100, units: 'px', default: 0, cssClasses: ['quarter']
        },
        marginLeft: {
            type: 'numeric', label: 'Слева', min: 0, max: 100, units: 'px',default: 0, cssClasses: ['quarter']
        },
        marginRight: {
            type: 'numeric', label: 'Справа', min: 0, max: 100, units: 'px', default: 0, cssClasses: ['quarter']
        },
        paddingTop: {
            type: 'numeric', label: 'Сверху', min: 0, max: 100, units: 'px', default: 0, cssClasses: ['quarter']
        },
        paddingBottom: {
            type: 'numeric', label: 'Снизу', min: 0, max: 100, units: 'px', default: 0, cssClasses: ['quarter']
        },
        paddingLeft: {
            type: 'numeric', label: 'Слева', min: 0, max: 100, units: 'px',default: 0, cssClasses: ['quarter']
        },
        paddingRight: {
            type: 'numeric', label: 'Справа', min: 0, max: 100, units: 'px', default: 0, cssClasses: ['quarter']
        },
        backgroundImage: {
            type: 'image', label: 'Фоновое изображение', cssClasses: ['full'], default: 'none'
        },
        backgroundColor: {
            type: 'color', label: 'Цвет фона', default: 'transparent', cssClasses: ['color']
        },
        backgroundSize: {
            type: 'string', label: 'Размещение фона', default: 'cover', cssClasses: ['stretch'],
            choices: [
                {value: 'auto', label: 'По размеру изображения'},
                {value: 'cover', label: 'Заполнить блок'},
                {value: 'contain', label: 'Поместить в блок'},
            ],
        }, 
        backgroundRepeat: {
            type: 'string', label: 'Повторение', default: 'no-repeat', cssClasses: ['stretch'],
            choices: [
                {value: 'no-repeat', label: 'Нет'},
                {value: 'repeat', label: 'Да'},
                {value: 'repeat-x', label: 'Только по горизонтали'},
                {value: 'repeat-y', label: 'Только по вертикали'},
            ],
        }, 
    }

    export default {
        name: 'BlockStyles',
        props: {
            data: {
                type: Object,
                default: function() { return {} }
            },
            allowed: {
                type: Array,
                default: null,
            },
            hidefilebrowser: {
                type: Boolean,
                default: false,
            },
            inline: {
                type: Boolean,
                default: false,
            },
            wrapper: {
                validator: function() { return true },
                default: null,
            },
        },
        data: function(){
            let data = {};
            let allowedProperties = this.allowed || this.getAllowedStyleProperties();

            for (const cssAttribute of allowedProperties) {
                let value = 0;

                if (this.data.style) {
                    if (!styleProperties[cssAttribute]) {
                        console.warn(cssAttribute+' is defined in block params, but no description provided');
                        continue;
                    }

                    if (styleProperties[cssAttribute]['type'] === 'numeric'){
                        value = parseInt(this.data.style[cssAttribute]);
                    } else if (styleProperties[cssAttribute]['type'] === 'image'){
                        if (this.data.style[cssAttribute]) {
                            value = this.data.style[cssAttribute].replace('url(','').replace(')','');
                        }
                    } else if (styleProperties[cssAttribute]['type'] === 'string'){
                        value = this.data.style[cssAttribute];
                    } else {
                        value = this.data.style[cssAttribute];
                    }

                    if (!value && styleProperties[cssAttribute]['default'] !== undefined) {
                        value = styleProperties[cssAttribute]['default']; 
                    }

                    data[cssAttribute] = value;
                } else {
                    if (!styleProperties[cssAttribute]) {
                        console.warn(cssAttribute+' style present in component params but not described');
                        continue;
                    }
                    data[cssAttribute] = styleProperties[cssAttribute]['default'] ;
                }
            }

            return {
                image: null,
                imageId:  this.data.bgImage ? this.data.bgImage.id : null,
                imageUrl:  this.data.bgImage ? this.data.bgImage.url : null,
                imageChanged: false,
                browser: false,
                resizeStartWidth: null,
                resizeDirection: null,
                resizeStartHeight: null,
                resizeStartPos: null,
                properties: data,
                updateTimeout: null,
                styleProperties: styleProperties,
                allowedProperties: [],
                bgImageHeight: this.data.bgImage ? this.data.bgImage.height : 200,
                bgImageWidth: this.data.bgImage ? this.data.bgImage.width : 200,
            }
        },
        computed: {
            styles: function(){
                let data = {}

                for (const cssAttribute of this.allowedProperties) {
                    if (this.properties[cssAttribute] || this.properties[cssAttribute] === 0) {
                        let units = '';

                        if (styleProperties[cssAttribute]['units']) {
                            units = styleProperties[cssAttribute]['units']; 
                        }

                        if (styleProperties[cssAttribute]['type'] === 'image') {
                            data[cssAttribute] = this.wrapImgUrl(this.properties[cssAttribute]);
                        } else { 
                            data[cssAttribute] = this.properties[cssAttribute] + units;
                        }
                    }
                }

                return data; 
            },
            nonEmptyStyleGroups: function(){
                return styleGroups.filter(x => !this.groupEmpty(x))

            }
        },
        watch: {
            allowed: function(value) {
                this.allowedProperties = value;
                this.$forceUpdate();
            },
        },
        beforeDestroy: function() {
            if (this.allowedProperties.includes('backgroundImage')) {
                this.saveEditedImage();
            }
        },
        mounted: function() {
            this.allowedProperties = this.allowed || this.getAllowedStyleProperties();
            if (Object.entries(this.data.style).length === 0 && this.data.style.constructor === Object) {
                this.$emit('init', this.styles);
            }
        },
        methods: {
            groupEmpty: function(group) {
                return [...new Set(group.items)].filter(
                    x => new Set(this.allowedProperties).has(x)
                ).length == 0;
            },
            getAllowedStyleProperties: function() {
                let allowedProperties = [];
                for (let component of this.$root.componentsRegistered) {
                    if (component.type === this.data.type) {
                        allowedProperties = component.styles;
                    };
                }
                for (let component of this.$root.componentsAvailable) {
                    if (component.type === this.data.type) {
                        allowedProperties = component.styles;
                    };
                }
                return allowedProperties;
            },
            validateUpdate: function(property, update=true) {
                let value = this.properties[property];
                if (styleProperties[property]['type'] === 'numeric') {
                    value = Math.abs(parseInt(value));

                    this.properties[property] = value;
                }
                if (update) {
                    this.$emit('change', this.styles);
                }
                return value;
            },
            emitChange: function() {
                this.$emit('change', this.styles);
            },
            increaseNumber: function(property) {
                let val = this.validateUpdate(property, false);

                val = val + 1;

                if (val >= styleProperties[property]['max']) {
                    val = styleProperties[property]['max']; 
                } 

                this.properties[property] = val;
                this.$emit('change', this.styles);
            },
            decreaseNumber: function(property) {
                let val = this.validateUpdate(property, false);

                val = val - 1;

                if (val <= styleProperties[property]['min']) {
                    val = styleProperties[property]['min']; 
                }

                this.properties[property] = val;
                this.$emit('change', this.styles);
            },
            disableSelect: function(e) {
                e.preventDefault();
            },
            wrapImgUrl: function(url) {
                if (url && url !== 'none') return "url('"+url+"')";
                return 'none';
            },
            unwrapImgUrl: function(url) {
                if (url && url !== 'none') return url.replace("url('", '').replace("')", ''); 
                return 'none';
            },
            startImgVerticalResize: function(e) {
                this.resizeStartPos = e.clientY;
                this.resizeStartHeight = parseInt(this.bgImageHeight) || 0;
                document.addEventListener('mousemove', this.imgVerticalResize, true);
                document.addEventListener('mouseup', this.stopImgVerticalResize, true);
                document.addEventListener('selectstart', this.disableSelect);
                document.body.style.cursor = 'row-resize';
            },
            stopImgVerticalResize: function(e) {
                this.resizeStartPos = null;
                document.removeEventListener('mousemove', this.imgVerticalResize, true);
                document.removeEventListener('mouseup', this.stopImgVerticalResize, true);
                document.removeEventListener('selectstart', this.disableSelect);
                document.body.style.cursor = 'auto';
            },
            imgVerticalResize: function(e) {
                let delta = e.clientY - this.resizeStartPos;
                this.bgImageHeight = this.resizeStartHeight + delta;
                this.updatePreview();
            },
            startImgHorizontalResize: function(e, direction) {
                this.resizeStartPos = e.clientX;
                this.resizeDirection = direction;
                this.resizeStartWidth= this.bgImageWidth || 0;
                document.addEventListener('mousemove', this.imgHorizontalResize, true);
                document.addEventListener('mouseup', this.stopImgHorizontalResize, true);
                document.addEventListener('selectstart', this.disableSelect);
                document.body.style.cursor = 'col-resize';
            },
            stopImgHorizontalResize: function(direction) {
                this.resizeStartPos = null;
                this.resizeDirection = null;
                document.removeEventListener('mousemove', this.imgHorizontalResize, true);
                document.removeEventListener('mouseup', this.stopImgHorizontalResize, true);
                document.removeEventListener('selectstart', this.disableSelect);
                document.body.style.cursor = 'auto';
            },
            imgHorizontalResize: function(e) {
                let delta = (e.clientX - this.resizeStartPos)*2;
                let width = 0;


                if (this.resizeDirection === 'left') {
                    width = Math.ceil(this.resizeStartWidth - delta);
                } else {
                    width = Math.ceil(this.resizeStartWidth + delta);
                }

                if (width < 20) width = 20;
                if (width > 362) width = 362;

                this.bgImageWidth = width; 
                this.updatePreview();
            },
            startVerticalResize: function(e) {
                this.resizeStartPos = e.clientY;
                if (!this.properties.height) {
                    this.properties.height = this.wrapper.clientHeight;
                }
                this.resizeStartHeight = parseInt(this.properties.height) || 0;
                document.addEventListener('mousemove', this.verticalResize, true);
                document.addEventListener('mouseup', this.stopVerticalResize, true);
                document.addEventListener('selectstart', this.disableSelect);
                document.body.style.cursor = 'row-resize';
            },
            startHorizontalResize: function(e, direction) {
                this.resizeStartPos = e.clientX;
                this.resizeDirection = direction;
                this.resizeStartWidth= parseInt(this.properties.width) || 0;
                document.addEventListener('mousemove', this.horizontalResize, true);
                document.addEventListener('mouseup', this.stopHorizontalResize, true);
                document.addEventListener('selectstart', this.disableSelect);
                document.body.style.cursor = 'col-resize';
            },
            stopVerticalResize: function(e) {
                this.resizeStartPos = null;
                document.removeEventListener('mousemove', this.verticalResize, true);
                document.removeEventListener('mouseup', this.stopVerticalResize, true);
                document.removeEventListener('selectstart', this.disableSelect);
                document.body.style.cursor = 'auto';
                this.$emit('change', this.styles);
            },
            stopHorizontalResize: function(direction) {
                this.resizeStartPos = null;
                this.resizeDirection = null;
                document.removeEventListener('mousemove', this.horizontalResize, true);
                document.removeEventListener('mouseup', this.stopHorizontalResize, true);
                document.removeEventListener('selectstart', this.disableSelect);
                document.body.style.cursor = 'auto';
                this.$emit('change', this.styles);
            },
            verticalResize: function(e) {
                let delta = e.clientY - this.resizeStartPos;
                this.properties.height = this.resizeStartHeight + delta;
                this.$emit('change', this.styles);
                if (this.properties.height < this.$parent.$el.clientHeight) {
                    this.properties.height = this.$parent.$el.clientHeight; 
                }
            },
            horizontalResize: function(e) {
                const mod = ['left', 'right'].includes(this.styles.align) ? 1 : 2;
                //ugly shit
                let delta = (e.clientX - this.resizeStartPos)/this.$parent.$parent.$el.clientWidth*100*mod;
                let percent = 100;

                if (this.resizeDirection === 'left') {
                    percent = Math.ceil(this.resizeStartWidth - delta);
                } else {
                    percent = Math.ceil(this.resizeStartWidth + delta);
                }

                if (percent > 100) percent = 100;
                if (percent < 20) percent = 20;

                this.properties.width = percent;
                this.$emit('change', this.styles);

            },
            updateProperty: function(value, property) {
                this.properties[property] = value;
                this.$emit('change', this.styles);
            },
            fileTypeMismatchMessage: function() {
                alert('Неподдерживаемый тип файла');
            },
            fileSizeExceededMessage: function() {
                alert('Размер файла не должен превышать '+this.maxSize+' байт');
            },
            removeImage: function() {
                this.image.remove();
                this.$emit('change', {...this.styles, backgroundImage: 'none'});
                this.$root.updateComponent(
                    this.data.id, 
                    {
                        bgImage: null 
                    }
                );
            },
            changeImage: function(id, url) {
                this.browser = false;
                this.imageId = id;
                this.imageUrl = url;
                this.image.scaleRatio = 1;
                this.$emit('change', {...this.styles, backgroundImage: this.wrapImgUrl(url)});
                this.$root.updateComponent(
                    this.data.id, 
                    {
                        style: {...this.styles, backgroundImage: this.wrapImgUrl(url)},
                        bgImage: {
                            'id': this.imageId,
                            'url': this.imageUrl,
                        },
                    }
                );
                this.image.refresh();
                this.updatePreview();
            },
            updatePreview: function() {
                if (this.data.bgImage) {
                    if (JSON.stringify(this.data.bgImage.metadata) === JSON.stringify(this.image.getMetadata())) {
                        this.imageChanged = false;
                    } else {
                        this.imageChanged = true;
                    }
                }
                let component = this;
                clearTimeout(this.updateTimeout);
                this.updateTimeout = setTimeout(function() {
                    component.properties.backgroundImage = component.wrapImgUrl(component.image.generateDataUrl('image/png', 1)); 
                    component.$emit('change', {...component.styles, backgroundImage: component.wrapImgUrl(component.image.generateDataUrl('image/png', 1)), backgroundImageId: component.imageId});
                }, 100)
            },
            saveOriginalImage: function() {
                let component = this;
                this.$root.lock();

                let postdata = {
                    file: this.image.originalImage.src
                }

                let url = '/upload/'; 
                if (this.$root.siteId) {
                    url = '/upload/' + component.$root.siteId + '/';
                }

                $.post( url, postdata, function(originres) {
                    //component.$emit('update', component.data.id, {
                        //'image': originres.url,
                        //'imageid': originres.id
                    //});
                    component.imageId = originres.id;
                    component.imageUrl = originres.url;
                    component.image.scaleRatio = 1;
                    component.$emit('change', {...component.styles, backgroundImage: component.wrapImgUrl(originres.url)});
                }).fail(function() {
                    alert( "Ошибка при сохранении оригинала изображения" );
                }).always(function( data ) {
                    component.$root.unlock();
                });;
            },
            restoreImageMetadata: function() {
                if (this.data.bgImage && this.image) {
                    this.image.applyMetadata(this.data.bgImage.metadata);
                }
            },
            saveEditedImage: function() {
                let component = this;
                let mime = 'image/jpeg';

                if (!this.image.hasImage()) return;

                if (this.data.bgImage) {
                    if (JSON.stringify(this.data.bgImage.metadata) === JSON.stringify(this.image.getMetadata())) {
                        this.imageChanged = false;
                        return;
                    }
                }

                this.$root.lock();

                let postdata = {
                    meta: JSON.stringify(this.image.getMetadata()), 
                    origin_id: this.imageId
                };


                if (this.image.originalImage.src.split(';')[0].includes('png')){
                    mime = 'image/png'; 
                }

                postdata['file'] = this.image.generateDataUrl(mime, 1);

                let url = '/upload/'; 

                if (this.$root.siteId) {
                    url = '/upload/' + component.$root.siteId + '/';
                }

                $.post(url, postdata, function(thumbres) {
                    component.$root.updateComponent(
                        component.data.id, 
                        {
                            style: {...component.styles, backgroundImage: component.wrapImgUrl(thumbres.url)},
                            bgImage: {
                                'id': component.imageId,
                                'url': component.imageUrl,
                                'height': component.bgImageHeight, 
                                'width': component.bgImageWidth,
                                'metadata': component.image.getMetadata()
                            },
                        }
                    );
                    component.imageChanged = false;
                    component.$root.unlock();
                }).fail(function() {
                    alert( "Ошибка при загрузке изображения" );
                }).always(function( data ) {
                    component.$root.unlock();
                });;
            },
            hasChanged: function() {
                if (!this.data.hasOwnProperty('metadata')) {
                    return true;
                }
                const keys = ['startX', 'startY', 'scale', 'orientation'];
                const stored = JSON.parse(this.data.metadata);
                const current = this.imageData.getMetadata();
                for (let i in keys) {
                    if (stored[keys[i]] != current[keys[i]]) {
                        return true;
                    }
                }
                return false;
            },
        }
    }
</script>
